import apiClient from './apiClient';

// Change password API
export const changePassword = async (passwordData) => {
  const response = await apiClient.put('/auth/change-password', passwordData);
  return response.data;
};
